import { render, staticRenderFns } from "./ClerkAddOrderNoteDialog.vue?vue&type=template&id=88c02118&scoped=true&"
import script from "./ClerkAddOrderNoteDialog.ts?vue&type=script&lang=js&"
export * from "./ClerkAddOrderNoteDialog.ts?vue&type=script&lang=js&"
import style0 from "./ClerkAddOrderNoteDialog.vue?vue&type=style&index=0&id=88c02118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c02118",
  null
  
)

export default component.exports